import React from 'react'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Alert, Button, Col, FormGroup, FormText, Input, Label, Row, Table } from "reactstrap";
import renderField from "./renderField";
import renderCheck from "./renderCheck";
import { StripeCheckout } from "react-stripe-checkout";
import { CardElement, injectStripe } from "react-stripe-elements";

const required = value => value ? undefined : 'Merci de remplir ce champ'

const onToken = token => {
    console.log(token);
};

const fillDefaultValue = () => {
    return;
};

const displayError = (submitFailed) => {

    if (submitFailed) {

        return (
            <Alert color="danger">
                Le formulaire contient des erreurs
            </Alert>
        );
    }

}

const ThirdStep = props => {
    let { handleSubmit, formValues, previous, submitting, submitFailed } = props;
    console.log(props);
    const prices = {};

    if (!formValues) {
        formValues = {};
    } else {
        if (formValues.modeReglement == "trim") {
            prices.domiciliation = 147;
            prices.mulitiplier = 3;
        } else if (formValues.modeReglement == "sem") {
            prices.domiciliation = 269;
            prices.mulitiplier = 6;
        } else {
            prices.domiciliation = 490;
            prices.mulitiplier = 12;
        }
        if (!formValues.reexpedition) {
            prices.multiplierReexpedition = 0;
        } else {
            if (formValues.reexpedition.semaine == "1") {
                prices.multiplierReexpedition = prices.mulitiplier;
                prices.reexpedition = 25
            } else {
                prices.multiplierReexpedition = prices.mulitiplier;
                prices.reexpedition = 35
            }
        }
        prices.reexpedition = 25;

        if (!formValues.notificationSMS) {
            prices.multiplierSms = 0;
        } else {
            prices.multiplierSms = prices.mulitiplier;
        }
        prices.sms = 10;

        if (!formValues.numeroGeo) {
            prices.multiplierGeo = 0;
        } else {
            prices.multiplierGeo = 1;
        }
        prices.geo = 15;

        if (!formValues.permanenceTel) {
            prices.multiplierPerm = 0;
        } else {
            prices.multiplierPerm = 1;
        }
        prices.perm = 50;

        if (!formValues.scanCourrier) {
            prices.mulitiplierScanCourrier = 0;
        } else {
            prices.mulitiplierScanCourrier = 1;
        }
        prices.scan = 39;

        prices.totalHT = (prices.domiciliation + (prices.multiplierReexpedition * prices.reexpedition)
            + (prices.multiplierSms * prices.sms)
            + (prices.multiplierGeo * prices.geo)
            + (prices.multiplierPerm * prices.perm)
            + (prices.mulitiplierScanCourrier * prices.scan));


        prices.tva = prices.totalHT * 0.2;
        prices.ttc = (prices.totalHT + prices.tva);
        prices.depot = (200);
        prices.total = (prices.totalHT + prices.tva + prices.depot);


        prices.totalHT = parseFloat(prices.totalHT).toFixed(2)
        prices.tva = parseFloat(prices.tva).toFixed(2)
        prices.ttc = parseFloat(prices.ttc).toFixed(2)
        prices.depot = parseFloat(prices.depot).toFixed(2)
        prices.total = parseFloat(prices.total).toFixed(2)
        prices.reexpedition = parseFloat(prices.reexpedition).toFixed(2);
        prices.sms = parseFloat(prices.sms).toFixed(2);
        prices.perm = parseFloat(prices.perm).toFixed(2);
        prices.scan = parseFloat(prices.scan).toFixed(2);
        prices.geo = parseFloat(prices.geo).toFixed(2);
        prices.domiciliation = parseFloat(prices.domiciliation).toFixed(2);

    }

    const defaultClt = 'Nouveau Client';
    const defaultEmail = 'customer@yopmail.com';

    return (
        <form onSubmit={handleSubmit}>
            {displayError(submitFailed)}
            <FormGroup tag="fieldset">
                <legend style={{ textDecoration: "underline" }}>11/ Conditions du service de domiciliation</legend>
                <FormGroup check>
                    <Field name="cgu" type="checkbox" label={<span>J'ai lu et j'accepte les <a href="/static/csd.pdf" target="_blank"> conditions du service de domiciliation</a></span>} component={renderCheck} validate={required} />
                </FormGroup>
            </FormGroup>
            <FormGroup tag="fieldset">
                <legend>12/ Récapitulatif</legend>
                <h3 hidden={formValues.modeReglement != "trim"}>Vous avez choisi l'option trimestrielle</h3>
                <h3 hidden={formValues.modeReglement != "sem"}>Vous avez choisi l'option semestrielle</h3>
                <h3 hidden={formValues.modeReglement != "ann"}>Vous avez choisi l'option annuelle</h3>
                <Table striped responsive>
                    <thead>
                        <tr>
                            <th>Services</th>
                            <th>Tarifs</th>
                            <th>Quantité</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Domiciliation</td>
                            <td>{prices.domiciliation} €</td>
                            <td>1</td>
                            <td>{prices.domiciliation} €</td>
                        </tr>
                        <tr>
                            <td>Réexpédition</td>
                            <td>{prices.reexpedition} €</td>
                            <td>{prices.multiplierReexpedition}</td>
                            <td>{prices.reexpedition * prices.multiplierReexpedition} €</td>
                        </tr>
                        <tr>
                            <td>Notification SMS</td>
                            <td>{prices.sms} €</td>
                            <td>{prices.multiplierSms}</td>
                            <td>{prices.sms * prices.multiplierSms} €</td>
                        </tr>
                        <tr>
                            <td>Numéro géographique</td>
                            <td>{prices.geo} €</td>
                            <td>{prices.multiplierGeo}</td>
                            <td>{prices.geo * prices.multiplierGeo} €</td>
                        </tr>
                        <tr>
                            <td>Permanence téléphonique</td>
                            <td>{prices.perm} €</td>
                            <td>{prices.multiplierPerm}</td>
                            <td>{prices.perm * prices.multiplierPerm} €</td>
                        </tr>
                        <tr>
                            <td>Scan Courrier</td>
                            <td>{prices.scan} €</td>
                            <td>{prices.mulitiplierScanCourrier}</td>
                            <td>{prices.scan * prices.mulitiplierScanCourrier} €</td>
                        </tr>
                        <tr>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td>TOTAL HT</td>
                            <td>{prices.totalHT} €</td>
                        </tr>
                        <tr>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td>TVA (20%)</td>
                            <td>{prices.tva} €</td>
                        </tr>
                        <tr>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td>TOTAL TTC</td>
                            <td>{prices.ttc} €</td>
                        </tr>
                        <tr>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td>Dépôt de Garantie</td>
                            <td>{prices.depot} €</td>
                        </tr>
                        <tr>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td style={{ border: "none", backgroundColor: "#ffffff" }}></td>
                            <td>Total à Régler</td>
                            <td>{prices.total} €</td>
                        </tr>
                    </tbody>
                </Table>
            </FormGroup>
            <Alert color="secondary" className="d-none" isOpen={true}>
                <FormGroup tag="fieldset">
                    <legend style={{ textDecoration: "underline" }}>13/ Informations Paiement</legend>
                    <FormGroup>
                        <Label>Nom du détenteur de la carte</Label>
                        {/* <Field name="nameCard" type="text" component={renderField} /> */}
                        <input type="text" name="nameCard" value={defaultClt} className="form-control" />
                    </FormGroup>
                    <FormGroup>
                        <Label>Email du détenteur de la carte (pour le reçu du paiement)</Label>
                        {/* <Field name="emailCard" type="email" component={renderField} /> */}
                        <input type="email" name="emailCard" value={defaultEmail} className="form-control" />
                    </FormGroup>
                    <FormGroup check>
                        <CardElement hidePostalCode />
                    </FormGroup>
                </FormGroup>
            </Alert>
            <p>
                Les informations sont collectées par <strong>ASEI CAQUINEAU</strong> en vue de la Gestion de formulaires de Domiciliation d’une société et des envois de messages. <br />
                Les données sont à seule destination de <strong>ASEI CAQUINEAU</strong>, de ses éventuels prestataires et des tiers autorisés dans l’objectif du respect de la Loi n° <em>90-614 du 12 juillet 1990</em>. <br />
                Pour plus d’information sur le traitement et vos droits sur vos données, <a href="https://www.asei.fr/politique-de-protection-de-donnees-et-cookies/">cliquez ici</a>.
            </p >
            <div>
                <Button onClick={previous}>
                    Retour
                </Button>
                <Button type="submit" className="float-right" color="success" disabled={submitting}>
                    {submitting ? "Redirection en cours" : "Payer"}
                </Button>
            </div>
        </form >
    )
}

function mapStateToProps(state) {
    return {
        formValues: getFormValues('wizard')(state),
    }
}

export default connect(mapStateToProps, null)(reduxForm({
    form: 'wizard', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    onSubmitFail: (errors) => window.scrollTo(0, 0),
})(ThirdStep));


// WEBPACK FOOTER //
// ./src/FourthStep.js